import { render, staticRenderFns } from "./TaskNotesList.vue?vue&type=template&id=2e0bff22&"
import script from "./TaskNotesList.vue?vue&type=script&lang=js&"
export * from "./TaskNotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports